<div [id]="ID()" [style.width]="width()" [style.height]="height()"></div>
